import * as React from 'react'
import { createContext } from "react";
import { GDataContext } from './GDataContext';
import { GraphDataset } from './models/GraphDataset.interface';
import { GraphNode } from './models/GraphNode.interface';


export interface IInteractiveGraphController {
  selectedNode: GraphNode | undefined;
  selectNode: (nodeid: string) => void;
  selectedPath: GraphDataset | undefined;
  selectPath: (path: GraphDataset) => void;
  zoomTo: (x: number, y: number, height: number) => void;
  setZoomTo: (onZoomCalled: (x: number, y: number, height: number)=> void) => void
}

export const InteractiveGraphControllerContext = createContext<IInteractiveGraphController>({
  selectedNode: undefined,
  selectNode: (nodeId) => undefined,
  selectedPath: undefined,
  selectPath: (path: GraphDataset) => undefined,
  zoomTo: (x: number, y: number, height: number) => undefined,
  setZoomTo: undefined
});


type Props = {
  children: any,
}

const InteractiveGraphControllerProvider = ({ children }: Props) => {
  const [selectedNodeId, setSelectedNodeId] = React.useState<string>(undefined);
  const [selectedNode, setSelectedNode] = React.useState<GraphNode|undefined>(undefined);
  const [selectedPath, setSelectedPath] = React.useState<GraphDataset|undefined>(undefined);
  const [zoomToObj, setZoomToObj] = React.useState({zoomTo: () => undefined});

  const graphContext = React.useContext(GDataContext);

  function resetSelection() {
    setSelectedNode(undefined);
    setSelectedNodeId(undefined);
  }

  React.useEffect(() => {
    if (graphContext.dataset && selectedNodeId) {
      const node = graphContext.getNode(selectedNodeId);
      if (node) {
        setSelectedNode(node);
      } else {
        resetSelection()
      }
    } else {
      resetSelection()
    }
  }, [graphContext.dataset, selectedNodeId]);

  React.useEffect(() => {
    if (selectedPath) {
      setSelectedNode(undefined);
      setSelectedNodeId(undefined);
    }
  }, [selectedPath]);

  function setZoomToFunc(func) {
    setZoomToObj({zoomTo: func});
  }

  return (
    <InteractiveGraphControllerContext.Provider value={{
      selectedNode: selectedNode,
      selectNode: setSelectedNodeId,
      selectedPath: selectedPath,
      selectPath: setSelectedPath,
      zoomTo: (zoomToObj as any).zoomTo,
      setZoomTo: setZoomToFunc,
    }}>
      {children}
    </InteractiveGraphControllerContext.Provider>
  );
};

export default InteractiveGraphControllerProvider;
